// extracted by mini-css-extract-plugin
export var brand = "_12-9";
export var button = "_12-0";
export var chevron = "_12-v";
export var chevronButton = "_12-w";
export var content = "_12-n";
export var danger = "_12-g";
export var dangerOutlined = "_12-h";
export var dark = "_12-l";
export var darkTheme = "_12-c";
export var extraSmall = "_12-4";
export var fullWidth = "_12-8";
export var ghost = "_12-d";
export var gray = "_12-t";
export var icon = "_12-p";
export var iconButton = "_12-s";
export var iconButtonBorder = "_12-x";
export var iconButtonBorderDark = "_12-y";
export var iconButtonBorderLight = "_12-z";
export var iconLeft = "_12-q";
export var iconRight = "_12-r";
export var large = "_12-1";
export var light = "_12-m";
export var medium = "_12-2";
export var micro = "_12-5";
export var nano = "_12-7";
export var outlined = "_12-k";
export var pending = "_12-a";
export var primary = "_12-i";
export var shadow = "_12-o";
export var small = "_12-3";
export var solidLight = "_12-e";
export var solidLightBrand = "_12-f";
export var spinner = "_12-u";
export var transparent = "_12-j";
export var warning = "_12-b";
export var wideNano = "_12-6";